import { makeStyles } from '@material-ui/core/styles';

export const useCertifiedFileModalStyles = makeStyles(() => ({
    large: {
        width: '86px',
        height: '86px',
        border: '2px solid var(--brand-secondary-dark)'
    },
    img: {
        width: '46px',
        height: '52px',
    },
    button: {
        width: '150px',
        height: '36px',
        'font-size': '14px',
        'font-weight': 400,
        'text-transform': 'none',
        '&:hover': {
            'background-color': 'var(--brand-primary)',
            color: 'white'
        },
    },
    icon: {
        color: 'white',
        'font-size': '24px',
        'font-weight': 300,
        'margin-left': '10px',
        cursor: 'pointer'
    }
}));
